import { Avatar, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { GenericAbortSignal } from "axios";
import { UserItemDto, UserItemDtoPaginatedList } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ListChildComponentProps } from "react-window";
import { GenericListDrawer, GenericListFilter, GenericListItemsType } from "views/common/GenericListDrawer";
import { UserProfileDialog } from "views/foundation/user/dialogs/UserProfileDialog";

////////////////////////////////////////////////////////////////////////////////

type ItemData = GenericListItemsType<UserItemDto>;

export type ListUsersFilter = {
    searchText: string;
    pageNumber: number;
    pageSize: number;
};

////////////////////////////////////////////////////////////////////////////////

export type RoleSelectorDrawerResult = {
    roleId: string;
    name: string;
};

interface IPros {
    title?: string;
    subtitle?: string;
    onGetData: (filter: ListUsersFilter, signal: GenericAbortSignal | undefined) => Promise<UserItemDtoPaginatedList>;
    onClose: () => void;
}

export const ListUsersDrawer: React.FC<IPros> = (props) => {

    const { title, subtitle, onClose, onGetData } = props;
    const { t } = useTranslation();

    const [selectedUser, setSelectedUser] = useState<string | null>(null);

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleGetData = (genericFilter: GenericListFilter, signal: GenericAbortSignal | undefined): Promise<UserItemDtoPaginatedList> => {
        return new Promise((resolve, reject) => {
            onGetData({
                ...genericFilter,
            }, signal)
                .then((response) => resolve(response))
                .catch(reject);
        });
    };

    /**
     * Renderiza uma linha da Lista.
     * @param props
     */
    function renderRow(props: ListChildComponentProps<ItemData>) {
        const { index, style } = props;
        const { items, onViewerClick } = props.data;

        const item = items[index];
        if (item == undefined) return <></>;
        return (
            <div key={index} style={style}>
                <ListItem
                    disablePadding
                    disableGutters
                    onClick={() => onViewerClick && onViewerClick(item)} className={AppGlobalClassKeys.clickable}
                >
                    <ListItemAvatar sx={{ minWidth: 40 }}>
                        <Avatar
                            src={item.thumbnailUrl}
                            sx={(theme) => ({ width: 32, height: 32, backgroundColor: theme.palette.grey[200] })}
                        />
                    </ListItemAvatar>
                    <ListItemText
                        primary={item.name}
                        title={item.name}
                        primaryTypographyProps={{ noWrap: true, variant: "h6" }}
                    />
                </ListItem>
            </div>
        );
    }

    ///
    function onItemClick(item: UserItemDto): void {
        setSelectedUser(item.userId);
    }

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <GenericListDrawer
            title={title || t("User.ListUsersDrawer.Title")}
            subtitle={subtitle}
            itemHeight={40}
            onClose={() => onClose()}
            onGetData={handleGetData}
            onViewerClick={onItemClick}
            emptyDataMessage={t("User.ListUsersDrawer.ThereAreNoResults")}
            emptyFilterMessage={t("User.ListUsersDrawer.NoRecordsFoundMessage")}
            recordCounterFormater={(count) => t("User.ListUsersDrawer.RecordsFoundText", { count })}
            renderRow={renderRow}
            footer={
                <UserProfileDialog
                    userId={selectedUser}
                    onClose={() => setSelectedUser(null)}
                />
            }
        />
    );
};
